import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core'
import { PackagingMaterialSpec } from '../../../package-type'
import { MatError, MatFormField, MatLabel } from '@angular/material/form-field'
import { FormsModule, NgModel } from '@angular/forms'
import { ElderTranslatePipe } from '@elderbyte/ngx-starter'
import {
  ElderPlugParentFormDirective,
  ElderSelectComponent,
  ElderSelectValueDirective,
  ElderValidationErrorDirective,
  SelectionModelPopupDirective,
} from '@elderbyte/ngx-starter'
import { MatInput } from '@angular/material/input'
import { MaterialBrowserComponent } from '../../../../../materials/material-browser/material-browser.component'
import { MaterialService } from '../../../../../materials/material.service'
import { Material } from '../../../../../materials/material'

@Component({
  selector: 'app-package-type-material-detail',
  imports: [
    FormsModule,
    ElderTranslatePipe,
    MatFormField,
    MatLabel,
    MatInput,
    MatError,
    ElderSelectComponent,
    ElderValidationErrorDirective,
    ElderPlugParentFormDirective,
    ElderSelectValueDirective,
    SelectionModelPopupDirective,
    MaterialBrowserComponent,
  ],
  template: `
    <div elderPlugParentForm class="full layout-row gap-xl p-xl">
      <mat-form-field elderDense>
        <mat-label>{{ 'context.material' | translate }}</mat-label>
        <elder-select
          name="materialId"
          class="flex"
          required
          [dataSource]="materialService"
          [entityId]="materialSpec().materialId"
          (valueChange)="materialSelectionChanged($event)"
          [displayProperty]="'id'"
        >
          <div *elderSelectValue="let value" class="layout-col">
            <span style="line-height: 20px">{{ value.description }}</span>
            <span class="mat-caption">{{ value.id }}</span>
          </div>
          <app-material-browser *elderSelectionModelPopup class="flex"> </app-material-browser>
        </elder-select>
      </mat-form-field>

      <mat-form-field class="flex layout-col" elderDense>
        <mat-label>{{ 'context.amount' | translate }}</mat-label>
        <input
          matInput
          name="presetQuantity"
          type="number"
          min="1"
          [required]="false"
          [(ngModel)]="materialSpec().presetQuantity"
        />
        <mat-error elderValidationError></mat-error>
      </mat-form-field>
    </div>
  `,
})
export class PackageTypeMaterialDetailComponent {
  readonly materialSpec = input.required<PackagingMaterialSpec>()
  readonly materialService = inject(MaterialService)

  materialSelectionChanged(material?: Material): void {
    if (material) {
      this.materialSpec().materialId = material.id
    }
  }
}
